import { useState } from 'react'
import Modal from '../Modal/Modal';
import Result from '../Result/Result';
import { Link } from 'react-router-dom'


import styles from './Home.module.css'

function Home() {

  const [options,setOptions]= useState({
    size: '', 
    headColor: '', 
    mainColors: [], 
    billShape: '', 
    upperColor: '', 
    bellyColor: '',
    location: ''
});

  const [isOpen, setIsOpen] = useState(false)

  const handleModal =(e) => {
    e.preventDefault()
    setIsOpen(true)
  }

 
  const user = JSON.parse(localStorage.getItem('profile'))


  if (!user?.result?.name) {
    return (
      <section className={styles.loginHero}>
          <div className={styles.overlay}>
            <div className={styles.text}>
              <h4 className="textContent">Identify West African bird species</h4>
              <Link style={{ textDecoration: 'none' }}  to="/login"><button className="loginBtn" >Login to Start</button> </Link>
            </div>
          </div>
         
      </section>
    )
  }

  return (
        <section className={styles.hero}>
        <h4>Identify West African bird species</h4>
          <button className="modalButton" onClick={handleModal}>Start Bird ID</button>
        <Modal isOpen={isOpen} setIsOpen={setIsOpen} options={options} setOptions={setOptions} />
        <Result options={options} />
      </section>
  )
}

export default Home;
